import React from 'react';
import { useImage } from 'react-image';
import Box from './layout/Box';

function Image({ source, backgroundColor, style, ...other }) {
  const { src, isLoading, error } = useImage({
    srcList: source,
    useSuspense: false,
  });

  return (
    <Box
      style={style}
      className="align-items-center justify-content-center"
      backgroundColor={backgroundColor}
      {...other}
    >
      {isLoading && (
        <div
          className="spinner-border spinner-border-sm text-light"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      )}

      {!isLoading && !error && <img src={src} style={style} />}
    </Box>
  );
}

Image.defaultProps = {
  source: '',
  style: {},
  backgroundColor: 'transparentColor',
};

export default Image;
